import { render, staticRenderFns } from "./CompanyDetailsPosting.vue?vue&type=template&id=1120632a&scoped=true&"
import script from "./CompanyDetailsPosting.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsPosting.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsPosting.vue?vue&type=style&index=0&id=1120632a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120632a",
  null
  
)

export default component.exports